<!-- <p>header works!</p>-->
<div class="header-container">
  <mat-toolbar
    [ngClass]="{
      'header-toolbar': screenSize == ScreenType.Desktop,
      'header-toolbar-tablet': screenSize == ScreenType.Tablet,
      'header-toolbar-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div
      [ngClass]="{
        'left-container': screenSize == ScreenType.Desktop,
        'left-container-tablet': screenSize == ScreenType.Tablet,
        'left-container-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <div
        *ngIf="screenSize != ScreenType.Mobile"
        class="hamburger-icon"
        (click)="onClickMenu()"
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div (click)="onClickAumYeLogo()" class="aumye-logo">
        <img src="assets/logo/horizontal_logo.png" />
      </div>
    </div>

    <div class="right-container">
      <div class="user-notification">
        <button
          mat-icon-button
          [matMenuTriggerFor]="notificationMenu"
          aria-label="Show notifications"
        >
          <mat-icon
            [matBadge]="unreadNotifications"
            [matBadgeHidden]="unreadNotifications === 0"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="above after"
          >
            notifications
          </mat-icon>
        </button>

        <mat-menu
          #notificationMenu="matMenu"
          class="notification-menu"
          xPosition="before"
          [overlapTrigger]="false"
        >
          <!-- Add notification header with counts -->
          <div class="notification-header">
            <div class="header-content">
              <h3 *ngIf="screenSize != ScreenType.Mobile">Notifications</h3>
              <div class="notification-counts">
                <span
                  class="count-badge unread"
                  [ngClass]="{ active: showUnreadOnly }"
                  (click)="toggleUnread($event)"
                  >{{ unreadNotifications }} unread</span
                >
                <span
                  class="count-badge read"
                  [ngClass]="{ active: showReadOnly }"
                  (click)="toggleRead($event)"
                >
                  {{ readNotifications }} Read
                </span>
                <span
                  class="count-badge total"
                  [ngClass]="{ active: showTotalOnly }"
                  (click)="toggleTotal($event)"
                  >{{ notifications.length }} total</span
                >
              </div>
            </div>
          </div>

          <div class="notification-container">
            <div
              *ngIf="filteredNotifications.length > 0"
              class="notification-viewport"
            >
              <div
                *ngFor="let notification of filteredNotifications"
                class="notification-item-container"
              >
                <div
                  class="notification-item"
                  [ngClass]="{ unread: !notification.read }"
                  (click)="openNotification(notification)"
                >
                  <div class="notification-icon">
                    <mat-icon
                      [ngClass]="getNotificationIconClass(notification)"
                    >
                      {{ getNotificationIcon(notification) }}
                    </mat-icon>
                  </div>
                  <div class="notification-content">
                    <div class="notification-header-row">
                      <div class="notification-title">
                        {{ notification.notificationTitle }}
                      </div>
                      <div
                        class="notification-time"
                        *ngIf="notification.timestamp"
                      >
                        {{ getTimeAgo(notification.timestamp) }}
                      </div>
                    </div>
                    <div class="notification-body">
                      {{ notification.notificationBody }}
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
              </div>
            </div>

            <div
              *ngIf="filteredNotifications.length === 0"
              class="no-notifications"
            >
              <mat-icon>notifications_off</mat-icon>
              <p>No notifications available</p>
            </div>
          </div>
        </mat-menu>
      </div>
      <div
        [ngClass]="{
          'user-name': screenSize == ScreenType.Desktop,
          'user-name-tablet': screenSize == ScreenType.Tablet,
          'user-name-mobile': screenSize == ScreenType.Mobile
        }"
        matTooltip="{{ userRole | uppercase }}"
      >
        {{ fullName }}
      </div>
      <div
        [ngClass]="{
          'user-avatar': screenSize == ScreenType.Desktop,
          'user-avatar-tablet': screenSize == ScreenType.Tablet,
          'user-avatar-mobile': screenSize == ScreenType.Mobile
        }"
        [matMenuTriggerFor]="beforeMenu"
      >
        <img
          [src]="profilePic.length <= 5 ? this.tempProfile : profilePic"
          alt="Avatar Logo"
          style="width: 50px"
          class="rounded-pill"
        />
      </div>
      <mat-menu #beforeMenu="matMenu" xPosition="before">
        <!-- <button mat-menu-item>Manage Visitor</button> -->
        <button mat-menu-item>
          <b><i>Org Name: </i></b>{{ orgName }}
        </button>
        <button mat-menu-item>
          <b><i>Role: </i></b> {{ userRole | uppercase }}
        </button>
        <button mat-menu-item>
          <div style="display: flex; justify-content: space-between">
            <div>
              <b><i>Gateway: </i></b> &nbsp;
              <span
                [ngStyle]="
              gatewaystatus === 'available'
                ? { 'background-color': 'green', }
                : { 'background-color': 'red', }
            "
                >{{ gatewaystatus | uppercase }}</span
              >
            </div>

            <i class="material-icons" style="max-width: 25">{{
              signalStatus
            }}</i>
          </div>
        </button>
        <button
          *ngIf="userRole !== 'device'"
          mat-menu-item
          (click)="onClickAccountSettings()"
        >
          Account settings
        </button>
        <button mat-menu-item (click)="onClickLogOut()">Log Out</button>
      </mat-menu>
    </div>
  </mat-toolbar>
</div>
<!-- LogOut Dialog Content -->
<ng-template #LogOutDialog>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
